import { Divider, Link } from '@mui/material';
import { NavBarDocs, SupportIcon } from '@ankr.com/ui';
import { t } from '@ankr.com/common';

import { DOCS_URL } from 'modules/layout/const';
import { Navigation } from 'modules/common/components/Navigation';
import { useAuth } from 'modules/auth/hooks/useAuth';
import { SUPPORT_PORTAL_LINK } from 'modules/common/constants/const';

import { AdditionalOptions } from './components/AdditionalOptions';
import { IUseMenuItemsProps, useMenuItems } from './hooks/useMenuItems';
import { MainNavigationSkeleton } from './MainNavigationSkeletion';
import { useMainNavigationStyles } from './useMainNavigationStyles';

export interface IMainNavigationProps extends IUseMenuItemsProps {
  handleSidebarClose?: () => void;
  isSigningOut: boolean;
}

export const MainNavigation = ({
  handleSidebarClose,
  isSigningOut,
  ...props
}: IMainNavigationProps) => {
  const { isMobileSideBar } = props;

  const { secondMenuItems, topMenuItems } = useMenuItems(props);

  const { classes } = useMainNavigationStyles();

  const { isLoggingIn } = useAuth();

  if (isLoggingIn || isSigningOut) {
    return <MainNavigationSkeleton />;
  }

  return (
    <div className={classes.root}>
      <div>
        <Navigation
          items={topMenuItems}
          isMobileSideBar={isMobileSideBar}
          handleSidebarClose={handleSidebarClose}
        />
        <Divider className={classes.divider} />
        <Navigation
          items={secondMenuItems}
          isMobileSideBar={isMobileSideBar}
          handleSidebarClose={handleSidebarClose}
        />
        <AdditionalOptions
          className={classes.additionalOptions}
          handleSidebarClose={handleSidebarClose}
        />
      </div>
      <div className={classes.footer}>
        <Link className={classes.link} href={DOCS_URL} target="_blank">
          <NavBarDocs className={classes.docIcon} />
          <span className={classes.linkText}>{t('main-navigation.docs')}</span>
        </Link>
        <Link
          className={classes.link}
          href={SUPPORT_PORTAL_LINK}
          target="_blank"
        >
          <SupportIcon className={classes.docIcon} />
          <span className={classes.linkText}>
            {t('main-navigation.support')}
          </span>
        </Link>
      </div>
    </div>
  );
};
